	import { Component,  BaseTLDetailComponent, AxiosResponse } from "../../../Infrastructure/CorBase/CoreBase";
import { TariffService, TariffFilter } from "../../../Services/AccBase/AllAccServices";

	export default abstract class  TariffDetailBase extends BaseTLDetailComponent {

		tariffService: TariffService = new TariffService();

		formData = {
			id: 0,
			name: '',
			description: '',
			maturityDay: '',
			urgentDay: ''
		};

		protected doAction() {
			super.doCRUDActionWithInfoMessage(this.$t('tariff.messageNew').toString(), this.$t('tariff.messageEdit').toString(), this.$t('tariff.messageDelete').toString());
		}

		protected fetchDataFromServer(): Promise<AxiosResponse<any>> {
			return this.tariffService.getById(this.objectId);
		}

		protected fetchRefreshDataFromServer(): Promise<AxiosResponse<any>> {
			return super.NoCall()
		}

		protected refreshItems(items: any, refreshData: any): any {
			return items;
		}

		protected processResponse(response: AxiosResponse<any>): void {
			this.formData.id = response.data.id;
			this.formData.name = response.data.name;
			this.formData.description = response.data.description;
			this.formData.maturityDay = response.data.maturityDay;
			this.formData.urgentDay = response.data.urgentDay;
		}

		protected afterCreate(response: AxiosResponse<any>): void {
			this.formData.id = response.data.id;
		}

		protected updateObject(): Promise<AxiosResponse<any>> {
			return this.tariffService.update(this.objectId, this.formData)
		}

		protected createObject(): Promise<AxiosResponse<any>> {		
			
			return this.tariffService.create(this.formData);
		}

		protected deleteObject(): Promise<AxiosResponse<any>> {
			return this.tariffService.delete(this.objectId);
		}
		
		vIsCorrectName: boolean = true;
		vIsCorrectMaturityDay: boolean = true;
		vIsCorrectUrgentDay: boolean = true;
	
		protected validateBase() {
			return !(this.vIsCorrectName && this.vIsCorrectMaturityDay && this.vIsCorrectUrgentDay);
		}
		
		protected isCorrectNameBase(value: any) {
			this.vIsCorrectName = value;
		}

		protected isCorrectMaturityDayBase(value: any) {
			this.vIsCorrectMaturityDay = value;
		}

		protected isCorrectUrgentDayBase(value: any) {
			this.vIsCorrectUrgentDay = value;
		}

	
	}
